import { render } from "./lastDetailsPublish.vue?vue&type=template&id=2a7f3afc"
import script from "./lastDetailsPublish.vue?vue&type=script&lang=js"
export * from "./lastDetailsPublish.vue?vue&type=script&lang=js"

import "./lastDetailsPublish.vue?vue&type=style&index=0&id=2a7f3afc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__